var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cartDishPrices"},_vm._l((_vm.data),function(price,index){return _c('div',{key:index,staticClass:"cartDishPrice"},[_c('span',[_vm._v(_vm._s(price.price)+" "+_vm._s(price.currency))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }